import React from 'react';
import Lottie from 'react-lottie';

import AnimationData from './lottie-animations/loadingShield.json';

class LoTAnimation extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            isStopped:false
        }
    }

    render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: AnimationData
        }

        return (
            <div>
                <Lottie options={defaultOptions}
                height={100}
                width={100}
                isStopped={this.state.isStopped}
                />
                <label>{this.props.text}</label>
            </div>
            

        )
    }
}

export default LoTAnimation;